<div class="store">
  <div class="store__number skeleton--animated"></div>
  <div class="details">
    <div class="details__brand skeleton--animated"></div>
    <div class="details__floor skeleton--animated"></div>
  </div>

  <span class="separator"></span>

  <div class="total">
    <div class="total__label skeleton--animated"></div>
    <div class="total__value skeleton--animated"></div>
  </div>

  <div class="chart">
    <div class="chart__label skeleton--animated"></div>
    <div class="chart__value skeleton--animated"></div>
  </div>

  <div class="foot-traffic">
    <div class="foot-traffic__label skeleton--animated"></div>
    <div class="foot-traffic__value skeleton--animated"></div>
  </div>
</div>


